import vueComponentOptions from 'components/InputFloat.vue';

const FloatInput = Vue.extend(vueComponentOptions);

module.exports = FloatInput;
